import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../../features/Auth/authSlice';
import { MenuOutlined, SettingOutlined } from '@ant-design/icons'; // Import icons
import { Dropdown, Menu, Button } from 'antd'; // Import Ant Design components
import './Header.css';
import logo from '../../assets/WhatsApp_Image_2025-01-20_at_9.35.44_pm-4-removebg-preview.png'

const Header = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleLogout = async () => {
    setIsLoggingOut(true); // Set loading state for visual feedback

    try {
      await dispatch(logout());
    } catch (error) {
      console.error('Logout error:', error);
      // Handle logout errors gracefully (e.g., display a message)
    } finally {
      setIsLoggingOut(false); // Reset loading state
    }
  };

  // Define the dropdown menu
  const menu = (
    <Menu>
      <Menu.Item key="profile" onClick={() => console.log('Profile clicked')}>
        Profile
      </Menu.Item>
      <Menu.Item key="logout" onClick={handleLogout} disabled={isLoggingOut}>
        {isLoggingOut ? 'Logging Out...' : 'Logout'}
      </Menu.Item>
    </Menu>
  );

  return (
    <div className="header">
      <button onClick={toggleSidebar} className="sidebar-toggle">
        <MenuOutlined />
      </button>
      <img src={logo} alt="Admin Panel Logo" className="header-logo-image" /> {/* Logo Image */}
      <Dropdown overlay={menu} trigger={['click']}>
        <Button type="text" className="settings-button">
          <SettingOutlined style={{ fontSize: '18px' }} />
        </Button>
      </Dropdown>
    </div>
  );
};

export default Header;